<template>
  <div @click="closeDatePick"
    v-loading.fullscreen.lock="allLoading"
    element-loading-text="上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    >
    <topBar @loadChange="loadChange"></topBar>
    <div class="m-con">
      <!--头部-->
      <!-- <h3 class="m-top-title">预定婚礼</h3> -->
      <ul class="m-top-bar">
        <template v-for="(menubar, index) in menuBar">
          <li class="m-chnum" :class="{ 'm-active': index <= menuIndex }">
            <p><span class="m-shuzi"></span></p>
            <p class="m-chtitle" :class="{ 'm-chtitle-left': index == 0 }">
              {{ menubar }}
            </p>
          </li>
          <li v-if="index <= 4">
            <p
              class="m-chline"
              :class="{ dashed: index === menuBar.length - 2 }"
            ></p>
          </li>
        </template>
      </ul>
      <!--中间内容区域-->
      <div class="m-body">
        <!-- <selectAgent v-if="cuindex == 0"></selectAgent>-->
        <!--暂时屏蔽单页
        <selectSer v-if="cuindex == 0"></selectSer>
        -->
        <selectSer v-if="cuindex == 0"></selectSer>
        <selectAgent
          v-if="cuindex == 1"
          :allData="serData"
          :currentProvinceInfo="currentProvinceInfo"
          :areaData="areaData"
        ></selectAgent>
        <fillForm v-if="cuindex == 2" :allData="serData" @changeChannelType="changeChannelType"></fillForm>
        <!--<fillForm v-if="cuindex == 1" :allData = "serData"></fillForm>-->
        <payFinsh v-if="cuindex == 3"></payFinsh>
      </div>
    </div>
    <footerBar></footerBar>
    <comfirmInfo
      v-if="comBox == 1"
      :serData="serData"
      :channelType="channelType"
      @chanLayer="changeLayer"
    ></comfirmInfo>
    <goPay
      v-if="comBox == 2"
      :serData="serData"
      @chanLayer="changeLayer"
    ></goPay>
  </div>
</template>

<script>
import footerBar from "../common/foot-bar-new.vue";
import topBar from "../common/top-bar-new.vue";
import selectSer from "../agent/selelct-service.vue";
import selectAgent from "../agent/select-agent.vue";
import fillForm from "../agent/fill-form.vue";
import comfirmInfo from "../agent/comfirm-info.vue";
import goPay from "../agent/go-pay.vue";
import payFinsh from "../agent/pay-finish.vue";
import CookieUtil from "@/plugin/cookie.js";
import api from "@/config/api.js";
import axios from "axios";
export default {
  name: "index",
  data: function () {
    return {
      channelType: 0,
      allLoading: false,
      cuindex: 0, //选择哪个组件弹出来
      menuIndex: 0, //用来判断圈圈是否需要变绿
      comBox: 0,
      serData: [],
      areaData: [],
      menuBar: [
        "选择服务",
        "选择顾问",
        "填写信息",
        "支付定金",
        "完成预定",
        "婚礼服务",
      ],
      currentProvinceInfo: null,
    };
  },
  components: {
    footerBar,
    topBar,
    selectSer,
    fillForm,
    comfirmInfo,
    goPay,
    payFinsh,
    selectAgent,
  },
  created: function () {
    this.queryProvince();
    //监控切换下一个页面按钮
    let vm = this;
    vm.bus.$on("updateIndex", function (obj) {
      vm.cuindex = obj.cuindex;
      vm.menuIndex = obj.menuIndex;
    });
    vm.bus.$on("comBox", function (obj) {
      vm.comBox = obj; //判断是拿个弹出层
    });
    vm.bus.$on("updateData", function (obj) {
      //保存数据 serData 第一个数据是服务ID 第二个数据是下单的信息
      console.log(obj);
      if (obj.serviceId) {
        vm.serData.splice(0, 1, obj); //选择服务 替换第一步selectID
      } else {
        if (vm.serData.length > 0) {
          vm.serData.splice(1, 1, obj);
        } else {
          vm.serData.push(obj);
          vm.serData.push(obj);
        }
      }
      console.log(vm.serData);

      setTimeout(() => {
        console.log("嘻嘻", vm.serData);
      }, 900);
    });
    //查询方法 查询支付完毕没有
    // 获取当前IP 所在省份
    this.getProvinceIPV2();
  },
  methods: {
    changeChannelType (val) {
      this.channelType = val
      console.log('----------支付跳转问题定位-2', this.channelType)
    },
    loadChange (val) {
      this.allLoading = val
    },
    getProvinceIPV2() {
      //实例化城市查询类
      var citysearch = new AMap.CitySearch();
      //自动获取用户IP，返回当前城市
      citysearch.getLocalCity((status, result) => {
        if (status === "complete" && result.info === "OK") {
          if (result && result.city && result.bounds) {
            console.log(result);
            this.currentProvinceInfo = {
              provinceName: (result && result.province) || "",
              cityName: (result && result.city) || "",
            };
          }
        }
      });
    },
    async queryProvince() {
      let result = [];
      let list = [];
      let url = api.NEW_BASE_URL + "tools-new/area/v1/query/list";
      let all_city = [];
      let vm = this;
      vm.getAjax(
        url,
        "",
        function (recomData) {
          console.log("recomData", recomData);
          if (recomData && recomData.code === 200) {
            vm.areaData = recomData.data || [];
            vm.areaData.forEach((item) => {
              if (item.citys) {
                let obj = {
                  id: "-1",
                  name: "",
                };
                item.citys.unshift(obj);
              }
            });
          }
        },
        function () {}
      );
    },
    closeDatePick: function () {
      this.bus.$emit("closePickData", false);
    },
    getHeight: function () {
      let wh = $(window).height(); //Windows的高度
      let apph = $(".m-con").height(); //页面高度
      let matop = wh - 320; //320是底部跟上面的高度
      if (matop > apph) {
        matop = matop - apph - 50; //减去本身有50的margin-bottom
        if (matop >= 50) {
          $(".m-con").css("margin-bottom", matop + "px");
        }
      }
    },
    changeLayer: function (obj) {
      this.cuindex = obj.cuindex;
      this.menuIndex = obj.menuIndex;
      this.comBox = obj.comBox;
    },
  },
  mounted: function () {
    //监听加载完后 页面的整体宽度
    this.getHeight();
    let vm = this;
    if (window.history && window.history.pushState) {
      $(window).on("popstate", function () {
        // 获得存储在该历史记录点的json对象var json=window.history.state;
        //监听后退
        if (vm.cuindex == 3) {
          //表示应该是此时已经预定成功 这时候返回 应该跳到一个页面
          vm.cuindex = 0;
          vm.menuIndex = 0;
          return;
        }
        if (vm.cuindex == 2) {
          //表示填写信息 往上一级 应该是经纪人页面
          if (vm.comBox == 2 || vm.comBox == 1) {
            if (vm.comBox == 2) {
              vm.menuIndex = 3;
            } else {
              vm.menuIndex = 2;
            }
            vm.comBox = 0;
          } else {
            //填写信息的时候 应该后退到选择经纪人
            vm.cuindex = 1;
            vm.menuIndex = 1;
          }
          return;
        }
        if (vm.cuindex == 1) {
          //0 表示选择服务
          vm.cuindex = 0;
          vm.menuIndex = 0;
          return;
        }
        if (vm.cuindex == 0) {
          //0 表示选择服务
          vm.menuIndex = 0;
          return;
        }
      });
      //window.history.pushState('', null, ''); //三个参数 state title url;
    } else {
    }
  },
  updated: function () {
    //监听加载完后 页面的整体宽度
    this.getHeight();
  },
};
</script>
<style>
@import "../../assets/css/base.css";
@import "../../assets/css/agent.css";
</style>
<style>
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: transparent;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0);
  border-radius: 10px;
  background-color: transparent;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0);
  background-color: #d6dcda;
}
</style>



// WEBPACK FOOTER //
// index.vue?7b4f9430